import { useEffect, useState } from "react";
import Spinner from "@/components/spinner";
import * as tripsService from "@/services/trips-service"
import { toast } from "react-toastify";
import ITripSearchResult from "@/models/trips/itrip-search-result";
import FormatDate from "@/components/formatting/format-date";
import { useNavigate } from "react-router";

interface IProps {
    guestId: number;
    closeModal: () => void;
}

const ViewGuestsTrips: React.FC<IProps> = ({ guestId, closeModal }) => {

    const [ isLoading, setIsLoading ] = useState<boolean>(true);
    const [ trips, setTrips ] = useState<ITripSearchResult[]>();

    const navigate = useNavigate();
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await tripsService.getTrips(guestId);
                
                setTrips(response);
            } catch {
                toast.error("The trips for this guest couldn't be loaded for an unknown reason.");
            }

            setIsLoading(false);
        }

        fetchData();
    }, [])

    return (
        <div className="w-11/12 lg:w-3/4 mx-auto">
            <div className='bg-br-blue-300'>
                
                <Spinner isLoading={isLoading}>
                    <div>
                        <h1 className="text-4xl md:text-6xl font-thin text-center pb-1 pt-3 mb-3">Trips for guest</h1>

                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-gray-800 border-dashed last:border-b-0">
                                    <th className="bg-gray-800 text-lg py-2 px-3">Retreat date</th>
                                    <th className="bg-gray-800 text-lg py-2 px-3">Instructor</th>
                                    <th className="bg-gray-800 text-lg py-2 px-3">Reservation date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {trips !== null && trips?.map(trip => (
                                    <tr 
                                        className="bg-gray-600 hover:bg-br-blue-400 duration-100 text-center cursor-pointer border-t border-dashed border-gray-400 first:border-solid first:border-gray-900"
                                        key={trip.tripId}
                                        onClick={() => navigate(`/view/${trip.retreatId}`, { state: { tripId: trip.tripId } })}
                                    >
                                        <td><FormatDate date={trip.startDate} includeDay={false} includeYear={true} /> - <FormatDate date={trip.endDate} includeDay={false} includeYear={true} /></td>
                                        <td>{trip.instructor}</td>
                                        <td><FormatDate date={trip.reservationDate} includeYear={true} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Spinner>

                <div className="flex justify-end mx-5 mt-4">
                    <button className="px-3 py-1 mb-2 bg-red-600 hover:brightness-110" onClick={() => closeModal()}>Close</button>
                </div>
            </div>
        </div>
    );
}

export default ViewGuestsTrips;